export class GrnRequest{
    grnId:number;
    
    constructor(grnId:number){
        this.grnId = grnId;
    }
}